module.exports = __webpack_public_path__ + "img/dedication.eb34e1a1.png";